import Axios from 'axios';
import HTTPService from './HTTPService';
import AxiosService from './AxiosService';
import { UserDetailsInterface, AuthenticateResponse } from '@/types/auth';

class AuthService {
  public login(username: string, password: string): Promise<AuthenticateResponse> {
    return new Promise((resolve, reject) => {
      const axios = AxiosService.getInstance();

      axios.post('/auth/authenticate', { username, password })
        .then((response) => resolve(response.data))
        .catch(reject);
    });
  }

  public logout(): Promise<void> {
    const axios = AxiosService.getInstance();

    return axios.get('/auth/logout')
      .then(() => Promise.resolve())
      .catch(() => Promise.resolve());
  }

  public resetPassword(
    username: string,
    newPassword: string,
    newPasswordConfirmation: string,
    resetToken: string,
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      const postData = HTTPService.formData({ username, newPassword, newPasswordConfirmation, resetToken });

      Axios.post('/auth/reset-password', postData)
        .then((response) => {
          if (response.data.successful) {
            resolve();
          }
        }).catch(reject);
    });
  }

  public isAuthenticated(): Promise<boolean> {
    return new Promise((resolve) => {
      this.fetchFreshUserDetails()
        .then(() => resolve(true))
        .catch(() => resolve(false));
    });
  }

  public hasStoredUser(): boolean {
    const user = JSON.parse(
      window.localStorage.getItem('user') as string,
    ) as UserDetailsInterface | null;

    return user !== null
      && user.id !== undefined
      && user.name !== undefined
      && user.email !== undefined
      && user.username !== undefined;
  }

  public storeUser(details: UserDetailsInterface): void {
    window.localStorage.setItem('user', JSON.stringify(details));
  }

  public clearStoredUser(): void {
    window.localStorage.removeItem('user');
  }

  public getStoredUser(): UserDetailsInterface | never {
    if (!this.hasStoredUser()) {
      throw new Error('No stored user found.');
    }

    return JSON.parse(
      window.localStorage.getItem('user') as string,
    ) as UserDetailsInterface;
  }

  public fetchFreshUserDetails(): Promise<UserDetailsInterface> {
    return new Promise((resolve, reject) => {
      const axios = AxiosService.getInstance();

      axios.get('/auth/user')
        .then((response) => {
          this.storeUser(response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  }
}

export default new AuthService();
